module.exports = __webpack_public_path__ + "media/Components/Logos/icon-text-cebfbcb93d5880a90360e0b123eaa0fb.svg";